import { ReactNode, SVGProps } from 'react'
import * as React from 'react'
import { HandbookItem, HandbookV2 } from 'types'
import { Icon } from 'almanac-ui/icons/Types'

export enum MenuType {
  contextMenu = 'contextMenu',
  popover = 'popover',
}

export interface MenuBaseProps {
  currentUserCanAccess: boolean
  onEdit?: () => void
  onTemplateChange?: (key?: string) => Promise<void>
}

export interface ContextMenuBaseProps extends MenuBaseProps {
  type: MenuType.contextMenu
  children: ReactNode
}

export interface ItemContextMenuProps extends ContextMenuBaseProps {
  item: HandbookItem
}

export interface ItemPopoverMenuProps extends MenuBaseProps {
  type: MenuType.popover
  children: undefined
  item: HandbookItem
}

export type ItemMenuProps = ItemPopoverMenuProps | ItemContextMenuProps | never

export type RootFolderProps = {
  handbook: HandbookV2
  children: ReactNode
}
export interface AddItemsMenuProps {
  onAction: (key: React.Key) => void
  withShare?: boolean
}

export enum ActionKey {
  edit = 'edit',
  delete = 'delete',
  copyLink = 'copyLink',
  createDoc = 'createDoc',
  addToTemplates = 'addToTemplates',
  createLink = 'createLink',
  createSection = 'createSection',
  openLinkInNewTab = 'openLinkInNewTab',
  copy = 'copy',
  share = 'share',
  move = 'move',
  favorite = 'favorite',
  settings = 'settings',
  rename = 'rename',
  statuses = 'statuses',
  handbookMode = 'handbookMode',
  versionControlMode = 'versionControlMode',
}

export const isActionKey = (k: React.Key): k is ActionKey => Object.values(ActionKey).includes(k as ActionKey)

export interface MenuItem {
  key: ActionKey
  Icon: React.FC<React.PropsWithChildren<SVGProps<SVGSVGElement>>> | Icon
  textValue: string
  canToggle?: boolean
  isToggled?: boolean
  enabledTooltip?: string
  disabledTooltip?: string
}

export type ActionHandler = (key: ActionKey) => boolean | Promise<boolean | undefined>

interface MenuProps {
  visible: boolean
  setVisible: (v: boolean) => void
  menus: MenuItem[][]
  handleAction: (key: ActionKey) => void
  disabledKeys?: Set<ActionKey>
}

export interface BaseContextMenuProps extends MenuProps {
  item?: HandbookItem
  type: MenuType.contextMenu
  children: ReactNode
}

export interface BasePopoverMenuProps extends MenuProps {
  item?: HandbookItem
  type: MenuType.popover
  children: undefined
}

export type BaseMenuProps = BaseContextMenuProps | BasePopoverMenuProps | never
